import React from 'react';
import StripeContext from './stripe-context';
import getStripe from './getStripe';

const stripe = getStripe();

export default function StripeProvider(props: React.PropsWithChildren<{}>) {
  return (
    <StripeContext.Provider
      value={{ stripe }}
    >
      {props.children}
    </StripeContext.Provider>
  );
}
